module.exports = "/images/trail-1.jpg";